export default {
  subtitle: "Reverse Exchange",
  path: "reverse_exchange",
  paragraphs: [
   "This request will be made when you want to pay an exact value in the final currency. For example, you want to pay from your USD account to a Brazilian customer in BRL, so you can put the final value in BRL without worrying about the amount that will be funded in USD."
  ],
  request:  {
    method: "POST",
    endpoint: "/transactions",
    payload: {
      "transaction": {
        "currency": "USD",
        "exchange_currency": "BRL",
        "exchanged_value": "500.00",
        "from_bank_account_id":  "your USD cash-out id",
        "to_bank_account_id":  "the customer’s account id",
        "subject_id": "Customer id"
      }
    }
  },
  parameterPayload: [
    {name: "transaction", type: "object", required: true, description: "An object containing all the required values needed"},
    {name: "transaction.currency", type: "string", required: true, description: "Currency from the internal account you would like to subtract"},
    {name: "transaction.exchange_currency", type: "string", required: true, description: "Currency you would like to pay"},
    {name: "transaction.exchanged_value", type: "string", required: true, description: "Value you would like to charge in the same currency as the \"exchange_currency\" field"},
    {name: "transaction.from_bank_account_id", type: "string", required: true, description: "ID of the internal account the funds will come from, it must be in the same currency as the \"currency\" field"},
    {name: "transaction.to_bank_account_id", type: "string", required: true, description: "ID of the physical/internal bank account that the funds will go to, it must be in the same currency as the \"exchange_currency\" field"},
    {name: "transaction.subject_id", type: "string", required: true, description: "ID of the person or company involved in the transaction"},
  ]
}




// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionReverseExchange.js